import { TSchema, Type } from "@sinclair/typebox";

export function OptionalOrNull<T extends TSchema>(type: T) {
	return Type.Optional(Type.Union([Type.Null(), type]));
}
